import { useDispatch, useSelector } from 'react-redux';
import {
  useCallback, useEffect, useState,
} from 'react';

import devicesApi from '@api/devicesApi';
import {
  useParams,
} from 'react-router-dom';

function useGeneralAlarma() {

  const dispatch = useDispatch();
  const { alarm_id } = useParams();

  const abortC = new AbortController();
  const { signal } = abortC;
  const skip = 0;
  const limit = 1000;

  const [displayState, setDisplayState] = useState('none');
  const [dataDevicesTypes, setDataDevicesTypes] = useState([]);
  const [dataGateway, setDataGateway] = useState([]);
  const createEdit = useSelector(({ alarms }) => alarms.createEditValues);

  const [businessData, setBusinessData] = useState([]);

  const getDeviceType = useCallback( // get the Api Device Type
    // change to portal data
    (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds !== '') {

          businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      devicesApi.getAllDeviceTypeUnifiedByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then((response) => {

          if (response.length > 0) {

            const newDevicesAll = response.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            const sortDevicesAll = newDevicesAll.sort((a, b) => {

              if (a.label < b.label) {

                return -1;

              }
              if (a.label > b.label) {

                return 1;

              }
              return 0;

            });

            setDataDevicesTypes(sortDevicesAll);

          }

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [dataDevicesTypes, dispatch]
  );

  const getGateway = useCallback( // get the Api Device Type
    // change to portal data
    (businessTypeIds) => {

      let businessTypeIdsQuery = '';

      if (businessTypeIds !== '') {

          businessTypeIdsQuery += `business_type_id=${businessTypeIds}`;

}

      devicesApi.getAllGatewayByBusiness(signal, skip, limit, businessTypeIdsQuery)
        .then((response) => {

          if (response.length > 0) {

            const newGateway = response.map((item) => ({
              value: item.mac,
              label: `${item.name} - ${item.mac}`,
            }));

            const sortGateway = newGateway.sort((a, b) => {

              if (a.label < b.label) {

                return -1;

              }
              if (a.label > b.label) {

                return 1;

              }
              return 0;

            });

            setDataGateway(sortGateway);

          }

        })
        .catch((error) => {

          // eslint-disable-next-line
          console.log('error: ', error);

        });

    },
    // eslint-disable-next-line
    [dataDevicesTypes, dispatch]
  );

  const onChangeOrigin = useCallback((e) => {

    if (e === 'Inst-Telemetry-Other') {

      setDisplayState('block');

    } else {

      setDisplayState('none');

    }

  }, [dispatch]);

  const readBusinessType = useCallback(async () => {

    await devicesApi.getAllBusinessType({ signal, skip, limit })
      .then(async (business) => {

          const newBusiness = await Promise.all(business.map(async (obj) => {

            const item = {
              value: obj.id,
              label: obj.name,
              devices: obj.total_general,
              clients: obj.total_general_clients,
              type: obj.type,
            };
            return item;

}));

          setBusinessData(newBusiness);

      }).catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          console.log('fem ', fem);

      });

  });

  const onDataChange = (value) => { // data imcomplete

    // eslint-disable-next-line
    getGateway(value);
    getDeviceType(value);

};

  useEffect(() => {

    if (createEdit?.origin) {

      if (createEdit.origin === 'Inst-Telemetry-Other') {

        setDisplayState('block');

      } else {

        setDisplayState('none');

      }

    }
    // eslint-disable-next-line
  }, [createEdit]);

  useEffect(() => {

    readBusinessType();
    getGateway(createEdit?.business_type_id);
    getDeviceType(createEdit?.business_type_id);
    // eslint-disable-next-line
  }, []);

  return {
    displayState,
    onChangeOrigin,
    dataDevicesTypes,
    dataGateway,
    createEdit,
    businessData,
    onDataChange,
    alarm_id,
  };

}

export default useGeneralAlarma;
